import { useEffect } from 'react'
import { rollbar } from 'utils/rollbar'

export default user => {
  useEffect(() => {
    if (user) {
      rollbar.configure({
        payload: {
          person: {
            id: user.id,
            username: user.name,
            email: user.email
          }
        }
      })
    }
  }, [user])
}
